<template>
  <div >
    <el-form inline size="small">
        <el-form-item label="检测编号">
            <el-input v-model="searchParams.task_no" placeholder="请输入检测编号" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
            <el-button size="small" @click="refresh">重置</el-button>
        </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id" >
      <el-table-column type="selection" align="center"  width="50"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
      <el-table-column label="检测编号" prop="task_no" align="center" width="200" show-overflow-tooltip></el-table-column>
      <el-table-column label="违规关键词" prop="sku_name_abnormal_words" width="135" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column label="违规尺码" prop="sku_size_abnormal_words" width="135" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column label="分组" prop="group_names" width="120" show-overflow-tooltip align="center"></el-table-column>

      <el-table-column label="已检测/总数" align="center" width="150" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag size="small" type="success">{{row.product_pro_count_total}}/{{row.product_count_total}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="异常数量" prop="product_pro_abnormal_count_total" align="center" width="100" show-overflow-tooltip></el-table-column>

      <!-- <el-table-column label="状态" prop="status" align="center"></el-table-column> -->
      <el-table-column align="center" label="状态" prop="status" width="100px">
        <template #default="{ row }">
          <el-tag size="small" type="warning" v-if="row.status == 1">待执行</el-tag>
          <el-tag size="small" type="success" v-else-if="row.status == 2">执行中</el-tag>
          <el-tag size="small" v-else-if="row.status == 3">完成</el-tag>
          <el-tag size="small" type="warning" v-else>异常</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="110" prop="created_at" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="{ row }">
          <!-- <el-tag size="small" type="success">{{row.product_pro_count_total}}/{{row.product_count_total}}</el-tag> -->
          <el-button size="small" @click="view_info(row)">查看策略</el-button>
          <el-button size="small" @click="view_abnormal(row)">查看异常</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total>0" />
    <el-dialog
      title="检测信息"
      :visible.sync="view_info_visible"
      width="50%">
      <CheckLowerPrice :info="skuCheckInfo"  ref="checkLowerPriceREF"></CheckLowerPrice>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions} from "vuex";

import Pagination from "@/components/pagination/pagination.vue";
import CheckLowerPrice from "./checkLowerPrice.vue";
export default {
  components: {
    Pagination,
    CheckLowerPrice
  },
  data() {
    return {
      view_info_visible:false,
      dataInfo:{},
      tableData:[],
      skuCheckInfo:{},
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
      searchParams:{
        task_no:''
      },
      selectData:[],
      loading: false,
    }
  },
  created() {
    // this.initData()
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      opGetSkudetectionPage: 'ucenter/opGetSkudetectionPage',
    }),
    initData(){
      this.refresh()
    },
    refresh(){
      this.page_data.page = 1
      this.page_data.total = 0
      this.searchParams = {
        task_no:''
      }
      this.getDataList()
    },
    handleSearch(){
      this.page_data.page = 1
      this.getDataList()
    },
    selectChange(e){
      this.selectData = [...e]
    },
    //获取检测列表
    getDataList() {
      this.loading = true
      let param = {page_size:this.page_data.limit,page:this.page_data.page,...this.searchParams}
      this.opGetSkudetectionPage({
        data: param,
        success: (res) => {
          this.loading = false
          console.log(res)
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    view_info(row) {
      this.view_info_visible = true
      this.skuCheckInfo = row
    },
    view_abnormal(row) {
       //=== 查看 ===
       this.$emit('view-abnormal', row.task_no)
    }
  }
}
</script>


<style scoped>
.w_120{
  width: 150px;
}
</style>
